import axios from "axios";
import axiosAuth from "src/util/axios";
import { loginUrl, resetUrl, verificationAndResetUrl, changePasswordUrl } from "src/react-query/endPoints";

// Authentication Services
// Login, reset, and verify use the global axios (no auth token needed)
async function login(loginData) {
  return await axios.post(loginUrl, loginData);
}

async function resetPassword(resetReqBody) {
  return await axios.post(resetUrl, resetReqBody);
}

async function verificationAndReset(verifyReqBody) {
  return await axios.post(verificationAndResetUrl, verifyReqBody);
}

// changePassword requires an authenticated session — use the interceptor instance
// so the token is injected consistently via the request interceptor
async function changePassword(changeReqBody) {
  return await axiosAuth.post(changePasswordUrl, changeReqBody);
}

const authService = {
  login,
  resetPassword,
  verificationAndReset,
  changePassword
};
export default authService;
